class ByteConvertUtilis {
    formatBytes(bytes: any, decimals = 2) {
        const kiloByte = 1024;
        const round = decimals < 0 ? 0 : decimals;
        const units = ["Bytes", "KB", "MB", "GB", "TB"];

        const convertion = Math.floor(Math.log(bytes) / Math.log(kiloByte));

        return `${parseFloat(
            (bytes / Math.pow(kiloByte, convertion)).toFixed(round)
        )} ${units[convertion]}`;
    }

    fromSvgToBlob(node: Node) {
        var doctype =
            '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">';

        var source = new XMLSerializer().serializeToString(node);
        return new Blob([doctype + source], { type: "image/svg+xml" });
    }
}

const byteConvertUtilis = new ByteConvertUtilis();

export default byteConvertUtilis;
